import { FC, useState } from 'react';

import { Box, Button, Modal, Paragraph, SectionTitle } from '@base-app';
import { Variants } from '@common/types';
import { ConfirmModalProps } from './ConfirmModal.types';

const ConfirmModal: FC<ConfirmModalProps<any>> = ({
  cancelAction,
  confirmAction,
  description,
  data = undefined,
  show,
  title,
}) => {
  const [isShowing, setIsShowing] = useState<boolean>(show);
  const handleClose = (): void => {
    setIsShowing(false);
    cancelAction.onClick();
  };

  const handleConfirm = (): void => {
    setIsShowing(false);

    confirmAction.onClick(data);
  };

  return (
    <Modal show={isShowing}>
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <SectionTitle css={{ fontWeight: '$bold', marginLeft: '$12', marginRight: '$12', textAlign: 'center' }}>
          {title}
        </SectionTitle>
        {description !== undefined && <Paragraph>{description}</Paragraph>}
        <Box css={{ marginTop: '$4', display: 'flex', flexDirection: 'column' }}>
          <Button id="modal-confirm-action" css={{ margin: '$2 $4' }} onClick={handleConfirm}>
            {confirmAction.text}
          </Button>
          <Button id="modal-cancel-action" css={{ margin: '$2 $4' }} variant={Variants.TERTIARY} onClick={handleClose}>
            {cancelAction.text}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmModal;
